import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'gas-table-sorting',
  templateUrl: './gas-table-sorting.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasTableSortingComponent {
  public sort$ = new BehaviorSubject<'default' | 'asc' | 'desc'>('default');
  public key$ = new BehaviorSubject<string>('');
  public isDesc$ = new BehaviorSubject<boolean>(false);

  public set sort(sorting: 'default' | 'asc' | 'desc') {
    this.sort$.next(sorting);
  }

  public get sort(): 'default' | 'asc' | 'desc' {
    return this.sort$.getValue();
  }

  public set key(key: string) {
    this.key$.next(key);
  }

  public get key(): string {
    return this.key$.getValue();
  }

  public set isDesc(isDesc: boolean) {
    this.isDesc$.next(isDesc);
  }

  public get isDesc(): boolean {
    return this.isDesc$.getValue();
  }

  constructor(
    public el: ElementRef,
  ) {}
}
